import ComingSoon from "../../Components/ComingSoon"

function Home() {
  return (
    <ComingSoon/>
  )
}

export default Home